import React, { Component, createRef } from "react";
import FormGroup from "../FormGroup/FormGroup";
class Textbox extends Component {
    constructor(props, context) {
        super(props, context);
        this._inputRef = createRef();
        this._handleChange = this._handleChange.bind(this);
    }
    render() {
        const { props } = this;
        return (<input ref={this._inputRef} {...props.attrs} type={props.type || "text"} className="textInput" value={props.value} onChange={this._handleChange}/>);
    }
    _handleChange(event) {
        this.props.onChange(event.currentTarget.value, event);
    }
    getInput() {
        return this._inputRef.current;
    }
}
class TextFormGroup extends Component {
    constructor() {
        super(...arguments);
        this._textboxRef = createRef();
    }
    render() {
        const { type, ...otherProps } = this.props;
        return (<FormGroup {...otherProps}>
				{(controlState) => (<Textbox ref={this._textboxRef} type={type} {...controlState}/>)}
			</FormGroup>);
    }
    getInput() {
        if (this._textboxRef.current != null) {
            return this._textboxRef.current.getInput();
        }
        return null;
    }
}
export default TextFormGroup;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/TextFormGroup/TextFormGroup.tsx